import { Injectable } from '@angular/core';
import { HttpHelperService } from './http-helper.service';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PowerBiCoreService {
  private baseUrl = environment.endpoint + '/powerbi-core';

  constructor(
    private httpHelperService: HttpHelperService,
  ) { }

  async getNavigation() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/navigation`,
      );
      if (result && result.response) {
        const items = result.response.items;
        resolve(Array.isArray(items) ? items : []);
      } else {
        reject('API ERROR');
      }
    });
  }

  async getReportsData(reports: { reportId: string; groupId: string; }[]) {
    return new Promise<any>(async (resolve, reject) => {
      console.log('PowerBiCoreService: Making request to:', `${this.baseUrl}/data`);
      console.log('PowerBiCoreService: Request payload:', { reports });

      // Add timeout to prevent hanging requests
      const timeoutId = setTimeout(() => {
        console.error('PowerBiCoreService: Request timeout after 30 seconds');
        reject(new Error('Request timeout'));
      }, 30000); // 30 seconds timeout

      try {
        const result: any = await this.httpHelperService.requestPromise(
          'POST',
          `${this.baseUrl}/data`,
          { reports },
        );

        clearTimeout(timeoutId); // Clear timeout on success
        console.log('PowerBiCoreService: Raw response from backend:', result);

        if (result && result.response) {
          console.log('PowerBiCoreService: Resolving with response:', result.response);
          resolve(result.response);
        } else {
          console.error('PowerBiCoreService: Invalid response structure - result:', result);
          reject('API ERROR: Invalid response structure');
        }
      } catch (error) {
        clearTimeout(timeoutId); // Clear timeout on error
        console.error('PowerBiCoreService: Request failed:', error);
        reject(error);
      }
    });
  }

  // async getGroups() {
  //   return new Promise<any>(async (resolve, reject) => {
  //     const result: any = await this.httpHelperService.requestPromise(
  //       'GET',
  //       `${this.baseUrl}/groups`,

  //     );
  //     if (result && result.response) {
  //       resolve(result.response);
  //     } else {
  //       reject('API ERROR');
  //     }
  //   });
  // }

  // async createUpdateGroup(newGroup: { code: string; name: string; }) {
  //   return new Promise<any>(async (resolve, reject) => {
  //     const result: any = await this.httpHelperService.requestPromise(
  //       'POST',
  //       `${this.baseUrl}/group`, { ...newGroup }
  //     );
  //     if (result && result.response) {
  //       resolve(result.response);
  //     } else {
  //       reject('API ERROR');
  //     }
  //   });
  // }

  // async deleteGroup(code: string) {
  //   return new Promise<any>(async (resolve, reject) => {
  //     const result: any = await this.httpHelperService.requestPromise(
  //       'DELETE',
  //       `${this.baseUrl}/group/${code}`
  //     );
  //     if (result && result.response) {
  //       resolve(result.response);
  //     } else {
  //       reject('API ERROR');
  //     }
  //   });
  // }

}
